export enum SigningEvents {
  COMPLETE = 'signing_complete',
  DECLINED = 'signing_declined'
}
